import { Box, Grid, Skeleton } from '@mui/material';

import { useLayout } from '../../../hooks/useLayout';
import styles from '../Card/CardItemSkeleton.module.sass';

//Скелетон карточки товара в сетку
const CardItemSkeleton = () => {
  const { page } = useLayout();
  return (
    <Grid
      sx={{ display: 'grid', marginTop: '8px' }}
      rowGap={1}
      item
      xs={6}
      sm={4}
      md={page === 'catalog' ? 6 : 4}
      lg={page === 'catalog' ? 4 : 3}
    >
      <Skeleton
        className={styles.title}
        animation="wave"
        variant="rounded"
        width={800}
        height={34}
      />{' '}
      {/* Title */}
      <Box className={styles.container}>
        <Box className={styles.wrapper}>
          <Skeleton
            animation="wave"
            variant="rounded"
            width={596}
            height={425}
          />{' '}
          {/* Name */}
          <Box className={styles.content}>
            <Box className={styles.content_top}>
              <Box className={styles.center}>
                <Box className={styles.center_top}>
                  <Skeleton
                    animation="wave"
                    variant="rounded"
                    width={114}
                    height={34}
                  />{' '}
                  {/* Price */}
                  <Skeleton
                    animation="wave"
                    variant="rounded"
                    width={142}
                    height={36}
                  />
                  <Skeleton
                    animation="wave"
                    variant="rounded"
                    width={126}
                    height={36}
                  />
                </Box>
                <Box className={styles.center_bottom}>
                  <Skeleton
                    animation="wave"
                    variant="rounded"
                    width={190}
                    height={44}
                  />{' '}
                  {/* Price */}
                  <Skeleton
                    animation="wave"
                    variant="rounded"
                    width={105}
                    height={24}
                  />
                </Box>
              </Box>
              <Box className={styles.right}>
                <Skeleton
                  animation="wave"
                  variant="rounded"
                  width={348}
                  height={252}
                />
              </Box>
            </Box>
            <Box className={styles.content_bottom}>
              <Skeleton
                className={styles.descr}
                animation="wave"
                variant="rounded"
                width={134}
                height={34}
              />
              <Skeleton
                animation="wave"
                variant="rounded"
                width="100%"
                height={225}
              />
            </Box>
          </Box>
        </Box>
        <Box className={styles.reviews}>
          <Skeleton
            animation="wave"
            variant="rounded"
            width={596}
            height={354}
          />
        </Box>
      </Box>
    </Grid>
  );
};

export default CardItemSkeleton;
